import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useNursing } from "./NursingLayout";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import InstituteMap from "@/components/InstituteMap";

export default function Contact() {
  const data = useNursing();
  const inst = data.institute || {};
  return (
    <div data-testid="nur-contact">
      <PageHero eyebrow="Get in touch" title="Reach the campus" />
      <PageBody>
        <div className="grid md:grid-cols-3 gap-5">
          <div className="bg-white rounded-2xl p-6 ring-1 ring-[#E2E8F0] hover:shadow-md transition-shadow">
            <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#0FB28A] to-[#0E916F] flex items-center justify-center text-white shadow-md">
              <Phone size={20} strokeWidth={1.5} />
            </div>
            <h3 className="mt-3 font-['Poppins',sans-serif] font-bold text-lg text-[#0F2A5F]">Call</h3>
            <ul className="mt-3 space-y-1.5 text-sm text-[#0F2A5F]">
              {inst.admission_phone && <li><a href={`tel:${inst.admission_phone.replace(/\s+/g, "")}`} className="hover:text-[#0FB28A]">{inst.admission_phone}</a> · Admissions</li>}
              {inst.contact_phone && <li><a href={`tel:${inst.contact_phone.replace(/\s+/g, "")}`} className="hover:text-[#0FB28A]">{inst.contact_phone}</a> · Office</li>}
            </ul>
          </div>
          <div className="bg-white rounded-2xl p-6 ring-1 ring-[#E2E8F0] hover:shadow-md transition-shadow">
            <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#0FB28A] to-[#0E916F] flex items-center justify-center text-white shadow-md">
              <Mail size={20} strokeWidth={1.5} />
            </div>
            <h3 className="mt-3 font-['Poppins',sans-serif] font-bold text-lg text-[#0F2A5F]">Email</h3>
            <ul className="mt-3 space-y-1.5 text-sm">
              {inst.email && <li><a href={`mailto:${inst.email}`} className="text-[#0F2A5F] hover:text-[#0FB28A] break-all">{inst.email}</a></li>}
            </ul>
          </div>
          <div className="bg-white rounded-2xl p-6 ring-1 ring-[#E2E8F0] hover:shadow-md transition-shadow">
            <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#0F2A5F] to-[#1B3E83] flex items-center justify-center text-white shadow-md">
              <MessageCircle size={20} strokeWidth={1.5} />
            </div>
            <h3 className="mt-3 font-['Poppins',sans-serif] font-bold text-lg text-[#0F2A5F]">WhatsApp</h3>
            <p className="mt-3 text-sm">
              {inst.whatsapp_phone ? (
                <a href={`https://wa.me/${inst.whatsapp_phone.replace(/[^0-9]/g, "")}`} target="_blank" rel="noopener noreferrer"
                   className="text-[#0F2A5F] hover:text-[#0FB28A]">Start chat →</a>
              ) : <span className="text-[#475569]">Not configured yet</span>}
            </p>
          </div>
        </div>

        <div className="mt-8 bg-gradient-to-br from-[#0F2A5F] to-[#0A1F47] text-white rounded-2xl p-7 shadow-lg relative overflow-hidden">
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-[#0FB28A]/30 rounded-full blur-3xl" />
          <div className="relative">
            <MapPin className="text-[#7FE7CE]" size={24} strokeWidth={1.5} />
            <h3 className="mt-2 font-['Poppins',sans-serif] font-bold text-xl">Campus Address</h3>
            <p className="mt-2 text-sm text-white/90">
              {[inst.address1, inst.address2, [inst.city, inst.pincode && `– ${inst.pincode}`].filter(Boolean).join(" "), inst.state, inst.country || "INDIA"]
                .filter(Boolean).join(", ") || "Address will be available soon."}
            </p>
          </div>
        </div>

        <div className="mt-6">
          <div className="text-xs uppercase tracking-[0.2em] text-[#0F2A5F] font-semibold mb-3">Find us on map</div>
          <InstituteMap
            latitude={inst.latitude}
            longitude={inst.longitude}
            address={[inst.address1, inst.city, inst.state, inst.country].filter(Boolean).join(", ")}
            testid="nursing-contact-map"
            className="w-full aspect-[16/9] rounded-2xl overflow-hidden ring-1 ring-[#E2E8F0] bg-slate-100"
          />
        </div>
      </PageBody>
    </div>
  );
}
